import React, { useContext } from 'react';
import { RotationControls, RotationDirection, ImageCropperContext } from '../../../libs/gs-component-image-upload';

interface Props {
  trackCoverPhotoRotation?: () => void;
}

const CropperPhotoRotation: React.FC<Props> = ({ trackCoverPhotoRotation }) => {
  const { rotateImageLeft, rotateImageRight } = useContext(ImageCropperContext);

  const rotateImage = (dir: RotationDirection): void => {
    if (dir === RotationDirection.Left) {
      rotateImageLeft();
      return;
    }

    rotateImageRight();
    trackCoverPhotoRotation && trackCoverPhotoRotation();
  };

  return <RotationControls onRotate={rotateImage} />;
};

export default CropperPhotoRotation;
